/*
  Kallfü — Favoritos sin cuenta (26-sep-2026).
  La lista vive en el navegador (localStorage), no en la cuenta de Shopify.
  Una sola lista. Clave por producto (handle); se guarda también la variante
  (tono) que se veía al guardar, para reabrir la ficha en ese tono.

  Marcado que usa:
  - Botón corazón:  [data-kf-fav] con data-handle, data-variant, data-title
                    (en la ficha, data-kf-fav-pdp: la variante se lee del formulario).
  - Contador:       [data-kf-fav-count] dentro del ícono del header.
  - Página:         [data-kf-fav-page] con [data-kf-fav-grid], [data-kf-fav-empty],
                    [data-kf-fav-actions] y [data-kf-fav-share].
*/
(function () {
  'use strict';

  var KEY = 'kallfu_favoritos';
  var MAX = 60;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (x) { return x && x.h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  function has(handle) {
    return read().some(function (x) { return x.h === handle; });
  }

  function add(item) {
    var list = read().filter(function (x) { return x.h !== item.h; });
    list.unshift(item);
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (x) { return x.h !== handle; }));
  }

  /* ---------- Aviso ---------- */
  var toastTimer;
  function toast(html) {
    var el = document.getElementById('kf-fav-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'kf-fav-toast';
      el.className = 'kf-fav-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    var close = el.querySelector('.kf-fav-toast__close');
    if (close) close.addEventListener('click', function () { el.classList.remove('is-open'); });
    el.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-open'); }, 4500);
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Estado visual ---------- */
  function sync() {
    var list = read();
    var saved = {};
    list.forEach(function (x) { saved[x.h] = true; });

    /* Solo se escribe lo que cambia: setAttribute con el mismo valor igual cuenta como
       una mutación del DOM (y le cuesta trabajo al navegador). */
    document.querySelectorAll('[data-kf-fav]').forEach(function (btn) {
      var on = !!saved[btn.getAttribute('data-handle')];
      var pressed = on ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') === pressed) return;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', pressed);
      btn.setAttribute('aria-label', on ? 'Quitar de Favoritos' : 'Guardar en Favoritos');
    });

    /* 27-sep-2026: escribir el texto SOLO si cambia. Reasignar textContent crea un nodo
       de texto nuevo aunque el valor sea el mismo; el MutationObserver de abajo lo veía
       como un cambio de la página y volvía a llamar a sync(): 60 ciclos por segundo. */
    var txt = list.length > 99 ? '99+' : String(list.length);
    document.querySelectorAll('[data-kf-fav-count]').forEach(function (el) {
      if (el.textContent !== txt) el.textContent = txt;
      if (el.hidden !== (list.length === 0)) el.hidden = list.length === 0;
    });
  }

  /* ---------- Medición ----------
     27-sep-2026: el píxel personalizado «Kallfü - Favoritos» (Shopify → Eventos de clientes)
     escucha estos eventos y los reenvía a GA4 (add_to_wishlist, remove_from_wishlist, share)
     y a Meta (AddToWishlist). Corre en un iframe aislado que no ve las cookies de la página,
     así que aquí se adjuntan el client_id y la sesión de GA4 para que el evento caiga en la
     MISMA persona y sesión que sus compras; y el id de producto, tono y precio para que
     calce con los informes de producto de GA4 (shopify_CL_<pid>_<vid>) y con el catálogo
     de Meta (retailer_id = id de la variante). */
  function cookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }

  function gaIds() {
    var out = {};
    var ga = cookie('_ga').split('.');                       // GA1.1.<a>.<b>
    if (ga.length >= 4) out.ga_client_id = ga[2] + '.' + ga[3];
    var s = cookie('_ga_YJQKE1Y839');
    var m2 = s.match(/^GS2\.\d+\.s(\d+)(?:\$o(\d+))?/);          // GS2.1.s<sesión>$o<n>$...
    if (m2) {
      out.ga_session_id = m2[1];
      if (m2[2]) out.ga_session_number = m2[2];
    } else if (/^GS1\./.test(s)) {                           // formato viejo: GS1.1.<sesión>.<n>...
      out.ga_session_id = s.split('.')[2];
      out.ga_session_number = s.split('.')[3];
    }
    return out;
  }

  var productCache = {};
  function productInfo(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  /* 29-sep-2026: eventos propios de Clarity, para poder filtrar las grabaciones de quien
     guarda, quita o comparte (el buscador de Clarity no distingue el clic en el corazón).
     Clarity corre en la página misma (no aislado), así que window.clarity existe; si aún
     no cargó, su snippet deja una cola que se procesa al cargar. */
  var CLARITY_EVENTS = {
    kallfu_agregar_a_favoritos: 'favoritos_guardar',
    kallfu_quitar_de_favoritos: 'favoritos_quitar',
    kallfu_compartir_favoritos: 'favoritos_whatsapp'
  };
  function clarityEvent(name, item) {
    try {
      if (typeof window.clarity !== 'function' || !CLARITY_EVENTS[name]) return;
      window.clarity('event', CLARITY_EVENTS[name]);
      if (item && item.h) window.clarity('set', 'favoritos_producto', item.h);
    } catch (e) {}
  }

  /* 30-sep-2026: la cookie _ga la escribe la app Google & YouTube unos segundos DESPUÉS de
     cargar la página (2,7 s con buena conexión; más en el navegador de Instagram con datos
     móviles). Antes, si el visitante tocaba el corazón antes de eso, el evento salía sin
     client_id y el píxel lo descartaba para GA4 (caso real: Perchero Organizador, 30-sep 00:30).
     Ahora se espera hasta 4 s a que aparezca la cookie antes de publicar el evento. Si no
     llega, se publica igual sin client_id (GA4 no lo recibe, Meta sí), como antes: no se
     inventa un identificador propio. Si la persona cambia de página antes, «pagehide» publica
     lo pendiente de inmediato. */
  function waitForGa(ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function poll() {
        if (gaIds().ga_client_id || Date.now() - t0 >= ms) return resolve();
        setTimeout(poll, 250);
      })();
    });
  }

  function enrich(data, p, item) {
    if (!p) return;
    data.product_id = p.id;
    data.product_type = p.type;
    var v = null;
    (p.variants || []).forEach(function (x) { if (String(x.id) === String(item.v)) v = x; });
    if (!v && p.variants && p.variants.length) v = p.variants[0];
    if (v) {
      data.variant_id = v.id;
      data.variant_title = v.public_title || v.title;
      data.sku = v.sku;
      data.price = v.price / 100;                              // /products/<h>.js viene en centavos
    }
  }

  var pending = [];

  function send(entry) {
    if (entry.sent) return;
    entry.sent = true;
    pending = pending.filter(function (x) { return x !== entry; });
    var ids = gaIds();
    Object.keys(ids).forEach(function (k) { entry.data[k] = ids[k]; });
    publish(entry.name, entry.data);
  }

  window.addEventListener('pagehide', function () { pending.slice().forEach(send); });

  function track(name, item, extra) {
    clarityEvent(name, item);
    var entry = { name: name, sent: false, data: {} };
    entry.data.currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';
    if (extra) Object.keys(extra).forEach(function (k) { entry.data[k] = extra[k]; });
    if (item && item.h) {
      entry.data.handle = item.h;
      entry.data.variant_id = item.v;
      entry.data.title = item.t;
    }
    pending.push(entry);
    var info = item && item.h
      ? productInfo(item.h).then(function (p) { enrich(entry.data, p, item); })
      : Promise.resolve();
    Promise.all([info, waitForGa(4000)]).then(function () { send(entry); });
  }

  /* ---------- Clic en el corazón ---------- */
  function pdpVariant(btn) {
    var scope = btn.closest('section, .product') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? input.value : btn.getAttribute('data-variant');
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-kf-fav]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();

    var handle = btn.getAttribute('data-handle');
    var title = btn.getAttribute('data-title') || '';
    if (!handle) return;

    if (has(handle)) {
      var saved = read().filter(function (x) { return x.h === handle; })[0];
      remove(handle);
      sync();
      toast('<span class="kf-fav-toast__text">Quitaste <b>' + esc(title) + '</b> de Favoritos</span>' +
        '<button type="button" class="kf-fav-toast__close" aria-label="Cerrar">×</button>');
      track('kallfu_quitar_de_favoritos', { h: handle, v: saved ? saved.v : null, t: title });
      if (document.querySelector('[data-kf-fav-page]')) renderPage();
      return;
    }

    var variant = btn.hasAttribute('data-kf-fav-pdp') ? pdpVariant(btn) : btn.getAttribute('data-variant');
    var item = { h: handle, v: variant ? Number(variant) : null, t: title, d: Date.now() };
    add(item);
    sync();
    btn.classList.remove('kf-pop');
    void btn.offsetWidth;
    btn.classList.add('kf-pop');
    toast('<span class="kf-fav-toast__text">Guardaste <b>' + esc(title) + '</b> en Favoritos</span>' +
      '<a class="kf-fav-toast__link" href="/pages/favoritos">Ver</a>' +
      '<button type="button" class="kf-fav-toast__close" aria-label="Cerrar">×</button>');
    track('kallfu_agregar_a_favoritos', item);
  }, true);

  /* ---------- Página /pages/favoritos ---------- */
  function itemUrl(x) {
    return '/products/' + encodeURIComponent(x.h) + (x.v ? '?variant=' + x.v : '');
  }

  function setCounts(page, n) {
    var countEl = page.querySelector('[data-kf-fav-total]');
    if (countEl) countEl.textContent = n === 0 ? '' : (n === 1 ? '1 producto' : n + ' productos');
    page.querySelector('[data-kf-fav-empty]').hidden = n > 0;
    page.querySelector('[data-kf-fav-actions]').hidden = n === 0;
    var note = page.querySelector('[data-kf-fav-note]');
    if (note) note.hidden = n === 0;
  }

  function renderPage() {
    var page = document.querySelector('[data-kf-fav-page]');
    if (!page) return;
    var grid = page.querySelector('[data-kf-fav-grid]');
    var list = read();

    setCounts(page, list.length);
    if (!list.length) { grid.innerHTML = ''; return; }

    var shown = {};
    grid.querySelectorAll('[data-kf-fav-item]').forEach(function (li) {
      var h = li.getAttribute('data-kf-fav-item');
      if (list.some(function (x) { return x.h === h; })) shown[h] = true; else li.remove();
    });

    var pending = list.filter(function (x) { return !shown[x.h]; });
    if (!pending.length) return;

    Promise.all(pending.map(function (x) {
      var url = itemUrl(x) + (x.v ? '&' : '?') + 'section_id=kallfu-favoritos-tarjeta';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { x: x, gone: true };
          return r.ok ? r.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('.card-wrapper');
            return card ? { x: x, html: card.outerHTML } : null;
          }) : null;
        })
        .catch(function () { return null; });
    })).then(function (res) {
      var byHandle = {};
      res.forEach(function (r) { if (r && r.html) byHandle[r.x.h] = r.html; });
      /* Productos que ya no existen o se despublicaron (404): se sacan de la lista.
         Un error de red NO borra nada; solo no se muestra esta vez. */
      var gone = res.filter(function (r) { return r && r.gone; }).map(function (r) { return r.x; });
      if (gone.length) {
        write(read().filter(function (x) { return !gone.some(function (g) { return g.h === x.h; }); }));
      }
      read().forEach(function (x) {
        if (!byHandle[x.h] || grid.querySelector('[data-kf-fav-item="' + CSS.escape(x.h) + '"]')) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.setAttribute('data-kf-fav-item', x.h);
        li.innerHTML = byHandle[x.h];
        grid.appendChild(li);
      });
      /* Mantener el orden de la lista (último guardado primero). */
      read().forEach(function (x) {
        var li = grid.querySelector('[data-kf-fav-item="' + CSS.escape(x.h) + '"]');
        if (li) grid.appendChild(li);
      });
      setCounts(page, read().length);
      sync();
      if (window.Loox && typeof window.Loox.init === 'function') {
        try { window.Loox.init(); } catch (e) {}
      }
    });
  }

  function shareUrl() {
    var lines = read().map(function (x) {
      return '• ' + (x.t || x.h) + '\n' + location.origin + itemUrl(x);
    });
    var text = 'Mis favoritos de Kallfü:\n\n' + lines.join('\n\n');
    return 'https://wa.me/?text=' + encodeURIComponent(text);
  }

  document.addEventListener('click', function (ev) {
    var share = ev.target.closest('[data-kf-fav-share]');
    if (share) {
      ev.preventDefault();
      window.open(shareUrl(), '_blank', 'noopener');
      track('kallfu_compartir_favoritos', null, { items_count: read().length, variant_ids: read().map(function (x) { return x.v; }).filter(Boolean) });
    }
  });

  /* ---------- Arranque ---------- */
  function init() {
    sync();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Tarjetas que llegan después (filtros, paginación, sliders).
     27-sep-2026: solo reacciona si lo agregado ES o CONTIENE un corazón. Antes reaccionaba
     a cualquier nodo nuevo, incluido el texto del contador que escribe sync(), y quedaba
     en un ciclo sin fin (60 por segundo, en todas las páginas). */
  var queued = false;
  function hasHeart(node) {
    return node.nodeType === 1 &&
      (node.hasAttribute('data-kf-fav') || !!node.querySelector('[data-kf-fav]'));
  }
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (hasHeart(added[j])) {
          queued = true;
          requestAnimationFrame(function () { queued = false; sync(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Otra pestaña cambió la lista. */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { sync(); renderPage(); }
  });

  window.KallfuFavoritos = { read: read, has: has, sync: sync };
})();
